var map = {
	"./file-extension/7zip.svg": 5788,
	"./file-extension/ace.svg": 12709,
	"./file-extension/aep.svg": 68154,
	"./file-extension/aepx.svg": 43886,
	"./file-extension/aet.svg": 43558,
	"./file-extension/ai.svg": 32370,
	"./file-extension/ait.svg": 25314,
	"./file-extension/avi.svg": 17942,
	"./file-extension/bmp.svg": 89097,
	"./file-extension/c.svg": 24091,
	"./file-extension/css.svg": 50573,
	"./file-extension/default.svg": 54447,
	"./file-extension/doc.svg": 30850,
	"./file-extension/docx.svg": 98966,
	"./file-extension/dotx.svg": 53327,
	"./file-extension/eps.svg": 39022,
	"./file-extension/flv.svg": 41212,
	"./file-extension/folder.svg": 96988,
	"./file-extension/gif.svg": 84282,
	"./file-extension/html.svg": 16327,
	"./file-extension/java.svg": 34696,
	"./file-extension/jpeg.svg": 92402,
	"./file-extension/jpg.svg": 15453,
	"./file-extension/js.svg": 75469,
	"./file-extension/less.svg": 58603,
	"./file-extension/m4a.svg": 14912,
	"./file-extension/mid.svg": 5118,
	"./file-extension/mp3.svg": 7766,
	"./file-extension/mp4.svg": 64153,
	"./file-extension/mpg.svg": 20090,
	"./file-extension/odf.svg": 53741,
	"./file-extension/ods.svg": 91696,
	"./file-extension/odt.svg": 85487,
	"./file-extension/otp.svg": 83507,
	"./file-extension/ots.svg": 92768,
	"./file-extension/ott.svg": 5791,
	"./file-extension/pdf.svg": 14962,
	"./file-extension/php.svg": 88064,
	"./file-extension/png.svg": 16621,
	"./file-extension/ppt.svg": 99812,
	"./file-extension/pptx.svg": 68084,
	"./file-extension/psd.svg": 2845,
	"./file-extension/py.svg": 13041,
	"./file-extension/qt.svg": 91623,
	"./file-extension/rar.svg": 42375,
	"./file-extension/raw.svg": 86698,
	"./file-extension/svg.svg": 48290,
	"./file-extension/tga.svg": 3304,
	"./file-extension/tgz.svg": 66387,
	"./file-extension/txt.svg": 82048,
	"./file-extension/wav.svg": 67874,
	"./file-extension/xls.svg": 53583,
	"./file-extension/xlsx.svg": 85637,
	"./file-extension/xml.svg": 1083,
	"./file-extension/zip.svg": 37733,
	"./gui/menu_toggle.svg": 45421
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 36492;